export type ShortsAudioPrefs = {
  muted: boolean
  volume: number
}

export const DEFAULT_SHORTS_AUDIO: ShortsAudioPrefs = {
  muted: false,
  volume: 50,
}

const STORAGE_KEY = 'haber-shorts-audio-v3'

export function loadShortsAudioPrefs(): ShortsAudioPrefs {
  if (typeof window === 'undefined') {
    return DEFAULT_SHORTS_AUDIO
  }
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return DEFAULT_SHORTS_AUDIO
    const parsed = JSON.parse(raw) as Partial<ShortsAudioPrefs>
    const volume = Number(parsed.volume)
    return {
      muted: Boolean(parsed.muted),
      volume: Number.isFinite(volume)
        ? Math.min(100, Math.max(0, volume))
        : DEFAULT_SHORTS_AUDIO.volume,
    }
  } catch {
    return DEFAULT_SHORTS_AUDIO
  }
}

export function saveShortsAudioPrefs(prefs: ShortsAudioPrefs) {
  if (typeof window === 'undefined') return
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(prefs))
  } catch {
    /* ignore */
  }
}
